{
    "QcQnr": {
        "position": {
            "x": 13,
            "y": 20,
            "z": 1
        },
        "key": "QcQnr",
        "tag": "goodspawn"
    },
    "6t1Ap": {
        "position": {
            "x": 14,
            "y": 20,
            "z": 1
        },
        "key": "6t1Ap",
        "tag": "goodspawn"
    },
    "6Z5Tx": {
        "position": {
            "x": 15,
            "y": 20,
            "z": 1
        },
        "key": "6Z5Tx",
        "tag": "goodspawn"
    },
    "mdPaA": {
        "position": {
            "x": 16,
            "y": 20,
            "z": 1
        },
        "key": "mdPaA",
        "tag": "goodspawn"
    },
    "a2pAK": {
        "position": {
            "x": 13,
            "y": 15,
            "z": 1
        },
        "key": "a2pAK",
        "tag": "goodspawn"
    },
    "76Tf4": {
        "position": {
            "x": 15,
            "y": 15,
            "z": 1
        },
        "key": "76Tf4",
        "tag": "goodspawn"
    },
    "Qr9Vk": {
        "position": {
            "x": 14,
            "y": 15,
            "z": 1
        },
        "key": "Qr9Vk",
        "tag": "goodspawn"
    },
    "rg4VU": {
        "position": {
            "x": 16,
            "y": 15,
            "z": 1
        },
        "key": "rg4VU",
        "tag": "goodspawn"
    },
    "yFmFq": {
        "position": {
            "x": 13,
            "y": 10,
            "z": 1
        },
        "key": "yFmFq",
        "tag": "goodspawn"
    },
    "_fYNT": {
        "position": {
            "x": 14,
            "y": 10,
            "z": 1
        },
        "key": "_fYNT",
        "tag": "goodspawn"
    },
    "WvSew": {
        "position": {
            "x": 16,
            "y": 10,
            "z": 1
        },
        "key": "WvSew",
        "tag": "goodspawn"
    },
    "v6y5h": {
        "position": {
            "x": 15,
            "y": 10,
            "z": 1
        },
        "key": "v6y5h",
        "tag": "goodspawn"
    },
    "e0TvZ": {
        "position": {
            "x": 16,
            "y": 17,
            "z": 1
        },
        "key": "e0TvZ",
        "tag": "badspawn"
    },
    "CIcji": {
        "position": {
            "x": 15,
            "y": 17,
            "z": 1
        },
        "key": "CIcji",
        "tag": "badspawn"
    },
    "lE8eI": {
        "position": {
            "x": 13,
            "y": 17,
            "z": 1
        },
        "key": "lE8eI",
        "tag": "badspawn"
    },
    "0LkZQ": {
        "position": {
            "x": 13,
            "y": 18,
            "z": 1
        },
        "key": "0LkZQ",
        "tag": "badspawn"
    },
    "uqp5m": {
        "position": {
            "x": 14,
            "y": 17,
            "z": 1
        },
        "key": "uqp5m",
        "tag": "badspawn"
    },
    "Codcz": {
        "position": {
            "x": 16,
            "y": 18,
            "z": 1
        },
        "key": "Codcz",
        "tag": "badspawn"
    },
    "fj0U2": {
        "position": {
            "x": 13,
            "y": 12,
            "z": 1
        },
        "key": "fj0U2",
        "tag": "badspawn"
    },
    "s2nad": {
        "position": {
            "x": 14,
            "y": 13,
            "z": 1
        },
        "key": "s2nad",
        "tag": "badspawn"
    },
    "Yi8j-": {
        "position": {
            "x": 13,
            "y": 13,
            "z": 1
        },
        "key": "Yi8j-",
        "tag": "badspawn"
    },
    "orb2Q": {
        "position": {
            "x": 14,
            "y": 12,
            "z": 1
        },
        "key": "orb2Q",
        "tag": "badspawn"
    },
    "VJaX4": {
        "position": {
            "x": 15,
            "y": 12,
            "z": 1
        },
        "key": "VJaX4",
        "tag": "badspawn"
    },
    "n8t1-": {
        "position": {
            "x": 15,
            "y": 13,
            "z": 1
        },
        "key": "n8t1-",
        "tag": "badspawn"
    },
    "FOryQ": {
        "position": {
            "x": 16,
            "y": 13,
            "z": 1
        },
        "key": "FOryQ",
        "tag": "badspawn"
    },
    "MLm8h": {
        "position": {
            "x": 16,
            "y": 12,
            "z": 1
        },
        "key": "MLm8h",
        "tag": "badspawn"
    },
    "PCQSC": {
        "position": {
            "x": 13,
            "y": 8,
            "z": 1
        },
        "key": "PCQSC",
        "tag": "badspawn"
    },
    "bD7V6": {
        "position": {
            "x": 14,
            "y": 8,
            "z": 1
        },
        "key": "bD7V6",
        "tag": "badspawn"
    },
    "hA1Hr": {
        "position": {
            "x": 15,
            "y": 8,
            "z": 1
        },
        "key": "hA1Hr",
        "tag": "badspawn"
    },
    "fTIdb": {
        "position": {
            "x": 16,
            "y": 8,
            "z": 1
        },
        "key": "fTIdb",
        "tag": "badspawn"
    },
    "Dl1RM": {
        "position": {
            "x": 16,
            "y": 7,
            "z": 1
        },
        "key": "Dl1RM",
        "tag": "badspawn"
    },
    "X--tN": {
        "position": {
            "x": 15,
            "y": 7,
            "z": 1
        },
        "key": "X--tN",
        "tag": "badspawn"
    },
    "6TY3G": {
        "position": {
            "x": 14,
            "y": 7,
            "z": 1
        },
        "key": "6TY3G",
        "tag": "badspawn"
    },
    "Ennkx": {
        "position": {
            "x": 13,
            "y": 7,
            "z": 1
        },
        "key": "Ennkx",
        "tag": "badspawn"
    },
    "pGf6G": {
        "position": {
            "x": 16,
            "y": 19,
            "z": 1
        },
        "key": "pGf6G",
        "tag": "goodspawn"
    },
    "4zG4C": {
        "position": {
            "x": 15,
            "y": 19,
            "z": 1
        },
        "key": "4zG4C",
        "tag": "goodspawn"
    },
    "pZOX-": {
        "position": {
            "x": 14,
            "y": 19,
            "z": 1
        },
        "key": "pZOX-",
        "tag": "goodspawn"
    },
    "fuEsv": {
        "position": {
            "x": 13,
            "y": 19,
            "z": 1
        },
        "key": "fuEsv",
        "tag": "goodspawn"
    },
    "fH20l": {
        "position": {
            "x": 16,
            "y": 14,
            "z": 1
        },
        "key": "fH20l",
        "tag": "goodspawn"
    },
    "nO_cA": {
        "position": {
            "x": 15,
            "y": 14,
            "z": 1
        },
        "key": "nO_cA",
        "tag": "goodspawn"
    },
    "_tmhj": {
        "position": {
            "x": 14,
            "y": 14,
            "z": 1
        },
        "key": "_tmhj",
        "tag": "goodspawn"
    },
    "pMvfA": {
        "position": {
            "x": 13,
            "y": 14,
            "z": 1
        },
        "key": "pMvfA",
        "tag": "goodspawn"
    },
    "a0PCh": {
        "position": {
            "x": 16,
            "y": 9,
            "z": 1
        },
        "key": "a0PCh",
        "tag": "goodspawn"
    },
    "xOUei": {
        "position": {
            "x": 15,
            "y": 9,
            "z": 1
        },
        "key": "xOUei",
        "tag": "goodspawn"
    },
    "j4tMY": {
        "position": {
            "x": 14,
            "y": 9,
            "z": 1
        },
        "key": "j4tMY",
        "tag": "goodspawn"
    },
    "Krc9T": {
        "position": {
            "x": 13,
            "y": 9,
            "z": 1
        },
        "key": "Krc9T",
        "tag": "goodspawn"
    },
    "E0BuR": {
        "position": {
            "x": 14,
            "y": 18,
            "z": 1
        },
        "key": "E0BuR",
        "tag": "badspawn"
    },
    "0CNk9": {
        "position": {
            "x": 15,
            "y": 18,
            "z": 1
        },
        "key": "0CNk9",
        "tag": "badspawn"
    },
    "WwTkW": {
        "position": {
            "x": 8,
            "y": 4,
            "z": 1
        },
        "key": "WwTkW",
        "tag": "badspawn"
    },
    "biQA5": {
        "position": {
            "x": 7,
            "y": 4,
            "z": 1
        },
        "key": "biQA5",
        "tag": "badspawn"
    },
    "2_IsM": {
        "position": {
            "x": 6,
            "y": 4,
            "z": 1
        },
        "key": "2_IsM",
        "tag": "badspawn"
    },
    "Cm8L4": {
        "position": {
            "x": 9,
            "y": 4,
            "z": 1
        },
        "key": "Cm8L4",
        "tag": "badspawn"
    },
    "9q3_f": {
        "position": {
            "x": 8,
            "y": 6,
            "z": 1
        },
        "key": "9q3_f",
        "tag": "goodspawn"
    },
    "woTvC": {
        "position": {
            "x": 7,
            "y": 6,
            "z": 1
        },
        "key": "woTvC",
        "tag": "goodspawn"
    }
}